import { makeStylesheetLink } from "../../stylesheet";
import { validateDeliveryForm } from "../../utils";
import { Checkout } from "./Checkout";

export class ContinueToPayment extends HTMLElement {

	shadow: ShadowRoot;
	button: HTMLButtonElement;

	onClick: () => void;

	constructor() {
		super();

		this.shadow = this.attachShadow({ mode: "open" });

		this.button = <button type="button" className="gct-btn-lg gct-w100">Continue to payment</button> as HTMLButtonElement;
		this.onClick = onClick.bind(this);

		this.shadow.append(this.button, makeStylesheetLink());
	}

	connectedCallback() {
		this.button.addEventListener("click", this.onClick);
	}

	disconnectedCallback() {
		this.button.removeEventListener("click", this.onClick);
	}
}

async function onClick(this: ContinueToPayment) {
	try {
		this.button.disabled = true;

		if (!validateDeliveryForm()) return;

		const deliveryTab = document.getElementById("panel-delivery");
		const paymentTab = document.getElementById("panel-payment");

		if (deliveryTab) deliveryTab.classList.add("gct-d-none");
		if (paymentTab) paymentTab.classList.remove("gct-d-none");

		const paymentFormLink = document.getElementById("btn-payment");
		if (paymentFormLink) {
			paymentFormLink.classList.remove("gct-checkout-tab-disabled");
			paymentFormLink.classList.add("gct-checkout-tab");
		}

		const deliveryFormLink = document.getElementById("btn-delivery");
		if (deliveryFormLink) {
			deliveryFormLink.classList.remove("gct-checkout-tab");
		}

		window.scrollTo(0, 0);

		/* TODO HACK: Blink doesn't work when refreshed while on different tab,
		 * so we force a refresh when going to it. We only need to do it the
		 * first time and at first we can get to billing tab only through this
		 * button.
		 */
		const checkout = document.querySelector<Checkout>("gct-checkout");
		checkout?.triggerUpdateCheckout();
	} finally {
		this.button.disabled = false;
	}
}
